import React from 'react'
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  TextField
  , Skeleton
} from '@mui/material'
import { useSelector } from 'react-redux'
import { userSlice } from '../../../../../../../reducers'
import useAccountInfo from '../../../hooks/useAccountInfo'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  sorry: {
    ...typography.heading.h5,
    fontWeight: typography.fontWeightMedium,
    color: palette.grey.shade[100],
    marginBottom: spacing(2)
  },
  reasonHeading: {
    color: palette.grey.shade[90],
    marginBottom: spacing(2)
  },
  reasonOption: {
    '& .MuiTypography-body1': {
      ...typography.body.s
    },
    color: palette.grey.shade[100]
  },
  optional: {
    color: palette.grey.shade[70]
  }
}))

const allReasons = [
  { label: "I don't have enough time", value: 'time' },
  { label: 'The plan was too expensive for me', value: 'expensive' },
  { label: 'I want to suspend my account', value: 'suspend' },
  { label: 'I left the company or changed my job', value: 'changed-job' },
  { label: 'I lost my job', value: 'lost-job' },
  { label: 'Other*', value: 'other' }
]

const ReasonPanel = ({ value, comment, setComment, onChange }) => {
  const profile = useSelector(userSlice.selectors.selectProfile)
  const classes = useStyles()
  const { isMonthlyPlan } = useAccountInfo()

  const handleChoiceChange = evt => {
    onChange(evt.target.value)
  }

  const handleCommentChange = evt => {
    setComment(evt.target.value)
  }

  // Only monthly plan users can suspend
  const reasons = isMonthlyPlan()
    ? allReasons
    : allReasons.filter(reason => reason.value !== 'suspend')

  return (
    <Box data-test='retention-reason-panel'>
      {profile
        ? (
          <Typography className={classes.sorry}>
            {profile.givenName}, we&apos;re sorry you&apos;re thinking of leaving
          </Typography>
          )
        : <Skeleton height='3em' />}
      <FormControl>
        <Typography
          variant='body1'
          id='cancel-reason-radio-buttons-group-label'
          className={classes.reasonHeading}
        >
          Which of these best describes your experience?
        </Typography>
        <RadioGroup
          value={value}
          onChange={handleChoiceChange}
          aria-labelledby='cancel-reason-radio-buttons-group-label'
          name='radio-buttons-group'
        >
          {reasons.map(({ label, value }, index) => (
            <FormControlLabel
              className={classes.reasonOption}
              key={value}
              value={value}
              control={
                <Radio
                  color='primary'
                  size='small'
                  inputProps={{
                    'data-test': `retention-reason-${index}-input`
                  }}
                />
              }
              label={label}
              data-test={`retention-reason-${index}-label`}
            />
          ))}
        </RadioGroup>
        {value === 'other' &&
          <>
            <TextField
              placeholder='Please write a reason here...'
              multiline
              variant='outlined'
              minRows={4}
              maxRows={4}
              margin='normal'
              onChange={handleCommentChange}
              value={comment}
              data-test='retention-reason-other-input'
            />
            <Typography variant='caption' className={classes.optional} data-test='retention-reason-other-optional'>*Optional</Typography>
          </>}

      </FormControl>
    </Box>
  )
}

export default ReasonPanel
